import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

// Equivalent of the mobile <Header /> (back button + title + subtitle + right slot).
export function Header({ title, subtitle, back = true, right }) {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-20 flex items-center gap-2 border-b border-[#222222] bg-[#121212]/90 px-4 py-3 backdrop-blur-md md:px-8">
      {back && (
        <button
          type="button"
          data-testid="header-back-button"
          aria-label="Retour"
          onClick={() => (window.history.length > 1 ? navigate(-1) : navigate("/", { replace: true }))}
          className="focus-ring flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#333333] bg-[#1E1E1E] text-white transition-colors hover:text-[#D4AF37]"
        >
          <ChevronLeft className="h-[22px] w-[22px]" />
        </button>
      )}
      <div className="min-w-0 flex-1">
        <h1 className="truncate font-display text-xl leading-[26px] text-white" data-testid="page-title">
          {title}
        </h1>
        {subtitle ? <p className="t-caption truncate">{subtitle}</p> : null}
      </div>
      {right}
    </header>
  );
}

// Title bar used on tab-root screens (no back button).
export function TopBar({ title, right, children }) {
  return (
    <div className="border-b border-[#222222] px-4 pt-4 md:px-8 md:pt-6">
      <div className="flex items-center gap-2">
        <h1 className="t-h1 flex-1">{title}</h1>
        {right}
      </div>
      {children}
    </div>
  );
}

export function Page({ children, testID }) {
  return (
    <div data-testid={testID} className="flex min-h-full flex-col">
      {children}
    </div>
  );
}

export function Content({ children, className = "", narrow }) {
  return (
    <div className={`mx-auto flex w-full flex-col gap-4 p-4 pb-8 md:p-8 ${narrow ? "max-w-3xl" : "max-w-6xl"} ${className}`}>{children}</div>
  );
}
